import {pdfTableStyle} from "../../../../../misc/pdf/parts/Page";
import {useContext} from "react";
import {PDFProjectContext} from "../../openings/OpeningsPDF";
import {css} from "@emotion/css";
import {ContainerPage} from "../../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../../misc/pdf/parts/TitleTextBlock";
import {Keying2Label} from "../../../../../api/Keying2";
import {formatProjectPdfRef} from "../../../../../api/Projects";

export function Legend(props: {
    names: Keying2Label[];
    noProject?: boolean
}) {
    const project = useContext(PDFProjectContext);

    return (
        <ContainerPage>
            <div>
                <TitleTextBlock title={
                    props.noProject ?
                        "KEYING DETAIL":
                        formatProjectPdfRef(project.projectNumber) + " - " + project.name + " - " + project.addressCity + ", " + project.addressProvince  + "- KEYING SCHEDULE"}>
                </TitleTextBlock>
            </div>

            <table className={pdfTableStyle + " " + legendStyle}>
                <tbody>
                <tr>
                    <th style={{textAlign: "left"}} colSpan={2}>KEYING DESIGNATION DESCRIPTIONS:</th>
                    <th># OF KEYS INCLUDED</th>
                </tr>
                {props.names.map(v => <tr>
                    <th>{v.name}</th>
                    <td>{!!v.title && !!v.description ? v.title + ": " : v.title} {v.description}</td>
                    <td>{v.keyCount}</td>
                </tr>)}
                </tbody>
            </table>
        </ContainerPage>
    )
}

const legendStyle = css({
    "& th:first-child": {
      borderLeft: "none",
    },
    "& td:first-child": {
      borderLeft: "none",
    },

    "& th:last-child": {
        borderRight: "none",
    },
    "& td:last-child": {
      borderRight: "none",
    },

    "& th, & td": {
        textAlign: "center",
    },

    "& tr:first-child th": {
        borderTop: "1px solid",
    }
})